import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveMenuId } from "../features/sidebar/sidebarSlice";

const PersonalProfile: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    return (
        <div className="w-full mx-auto px-4 py-6">
            {/* Section Title */}
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-3xl font-semibold text-[#17243E]">Personal Profile</h2>

                <button
                    className="text-[#000000] hover:text-black"
                    onClick={() => {
                        dispatch(setActiveMenuId("settings"));
                        navigate("/profile-setting");
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
                    </svg>
                </button>
            </div>

            {/* Green Profile Header */}
            <div className="bg-[#ABD405] rounded-md p-6 flex flex-col sm:flex-row items-start sm:items-center gap-6">
                <img
                    src="https://i.ibb.co/NTLFK1Y/sample-pic.png"
                    alt="profile"
                    className="w-24 h-24 rounded-md object-cover"
                />

                <div>
                    <h1 className="text-4xl font-bold text-[#000000]">Jenna Deo</h1>
                    <p className="text-sm text-[#000000] font-medium">Senior Commercial Officer</p>

                    <p className="text-xs font-medium text-[#000000] mt-1">Jenna.deo@creativplus.com</p>
                    <p className="text-[10px] font-medium text-[#000000]">Dubai, United Arab Emirates</p>
                </div>
            </div>

            {/* About Section */}
            <div className="bg-white rounded-md p-6 shadow-sm border border-[#000000]/20 mt-6">
                <h3 className="text-xl font-semibold text-[#000000] mb-3">About</h3>

                <p className="text-base text-[#000000] leading-relaxed mb-4">
                    Jenna Smith Deo is a Commercial Officer focused on strengthening client
                    relationships and driving revenue growth. He works across sales,
                    strategy, and operations to improve commercial performance and deliver
                    measurable results. His approach is data-driven, practical, and aimed
                    at helping the business stay competitive in a fast-moving market.
                </p>

                <p className="text-base text-[#000000] leading-relaxed mb-4">
                    Experienced in identifying new business opportunities and converting
                    them into profitable partnerships. Able to streamline commercial
                    processes to reduce inefficiencies and support faster decision-making.
                    Committed to delivering measurable outcomes that strengthen the
                    company’s market position.
                </p>
            </div>
        </div>
    );
};

export default PersonalProfile;
